// src/store/index.js  (ou le fichier où tu définis ton store)
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage

// tes reducers existants
import {
  auth,
  users,
  categories,
  parcours,
  domaines,
  quizzprofile,
  questions,
  gameZone,
  choices,
  tentatives,
  tutoriels,
  reset,
  technologies,
  niveau,
  tester_niveau,
} from "../reducers";

import challengeProfile from "../reducers/exercice_zone/challengeProfile";
import challengeZone from "../reducers/exercice_zone/challengeZone";
import exercices from "../reducers/exercice_zone/exercices";
import reponses from "../reducers/exercice_zone/reponses";
import tentativesChallenge from "../reducers/exercice_zone/tentativesChallenge";

// RTK Query API slice
import coachApi from "../api/coachApi";

// 1) On combine tous les reducers en un seul rootReducer
const rootReducer = combineReducers({
  auth,
  users,
  categories,
  parcours,
  domaines,
  quizzprofile,
  questions,
  gameZone,
  choices,
  tentatives,
  tutoriels,
  reset,
  technologies,
  niveau,
  tester_niveau,
  challengeProfile,
  challengeZone,
  tentativesChallenge,
  exercices,
  reponses,
  // reducer RTK Query
  [coachApi.reducerPath]: coachApi.reducer,
});

// 2) Config de persist : on persiste uniquement `auth`
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // <--- n'enregistre que auth (sécurité + propreté)
};

// 3) On crée le reducer persistant
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4) Création du store (attention au serializableCheck pour redux-persist)
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // ignore les actions de redux-persist (sinon warning)
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(coachApi.middleware), // on garde ton middleware RTK Query
  devTools: true,
});

// 5) Exporter le persistor pour l'utiliser ailleurs (ex: index.js, logout)
export const persistor = persistStore(store);
